import * as types from './mutation-types'

export default { 
  [types.GET_WALLET_HISTORIC](state, payload = { walletHistoric }) {
    state.walletHistoric = payload.walletHistoric
    state.walletHistoricLoaded = true
  },
  [types.SUM_WALLET_TRANSACTIONS](state, payload = { totalTransactions }) {
    state.totalTransactions = payload.totalTransactions
    state.cache.totalTransactionsLoaded = true
  },
  [types.GET_DISCOUNT_COUPONS](state, payload = { discountCoupons }) {
    state.discountCoupons = payload.discountCoupons
    state.discountCouponsLoaded = true
  },  
  [types.GET_COUPONS_CAMPAIGN](state, payload = { couponsCampaign }) {
    state.couponsCampaign = payload.couponsCampaign
    state.couponsCampaignLoaded = true
  },
}
